export default __webpack_public_path__ + "static/media/rec.5b3e24c5.svg";